module.exports = __webpack_public_path__ + "img/apple-pay.9119ae6a.svg";